import type { Surface } from '../../shell/router.js';
import { ContactSheet } from './ContactSheet.js';
import { PackingDesk } from './PackingDesk.js';
import { PlayStage } from './PlayStage.js';

/**
 * Contact sheet, Play stage and Packing desk, in that order.
 *
 * They are stages of one pass rather than modes: the sheet is where every Candidate is
 * scanned, opening one puts it inside a listing, and the desk states what leaves. The
 * Journey strip already reads `compare` and `export`, so the sequence follows the route
 * the operator is already on.
 */
export const surfaces: readonly Surface[] = [
  {
    id: 'experiment-compare',
    path: '/experiments/:experimentId/compare',
    title: 'Compare',
    render: (params) => <ContactSheet experimentId={params.experimentId ?? ''} />,
  },
  {
    id: 'experiment-compare-candidate',
    path: '/experiments/:experimentId/compare/:candidateId',
    title: 'Play stage',
    render: (params) => <PlayStage experimentId={params.experimentId ?? ''} candidateId={params.candidateId ?? ''} />,
  },
  {
    id: 'experiment-export',
    path: '/experiments/:experimentId/export',
    title: 'Export',
    render: (params) => <PackingDesk experimentId={params.experimentId ?? ''} />,
  },
];
